<!-- 大屏团体成绩查询 -->
<template>
    <div class="score-table">
        <div >
            {{ errorMessage }}
        </div>  
        <div v-if="isShow" class="custom-table2">            
            <div class="title">{{ title }} 团体排名 </div>     
            <el-table :data="tableData" class="custom-table" 
                :row-class-name="tableRowClassName" border>
                <el-table-column   
                    v-for="(item, index) in dynamicHeaders"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label" 
                    align="center">
                </el-table-column>             
            </el-table> 
        </div>   
    </div>
 </template>
 
 <script>
import { mapState } from 'vuex'

 export default {
     data() {
         return {
            title:'',
            activeA: 0,
            activeB: 0,
            dataList: [],
            tableData: [],
            ready: false,
            originPok: [],
            deskNo: 1,
            playersId: 1,
            thingPoker: '',
            northSouthPoker: '',
            showPoker: true,
            isShow: false,
            errorMessage: '',
            tableHeaders: [
               {label: '名次', prop: 'rank'},
                {label: '单位',prop: 'company'},
                {label: '选手', prop: 'username'},
                {label: '搭档名称', prop: 'partnerName'},
                {label: '总升级', prop: 'winNum'},
                {label: '第1轮_组A', prop: 'roud1A'},
                {label: '第1轮_组B', prop: 'round1B'},               
                {label: '第1轮_组A升级', prop: 'level1A'},
                {label: '第1轮_组B升级', prop: 'level1B'},   

                {label: '第2轮_组A', prop: 'roud2A'},
                {label: '第2轮_组B', prop: 'round2B'},               
                {label: '第2轮_组A升级', prop: 'level2A'},
                {label: '第2轮_组B升级', prop: 'level2B'}, 

                {label: '第3轮_组A', prop: 'roud3A'},
                {label: '第3轮_组B', prop: 'round3B'},               
                {label: '第3轮_组A升级', prop: 'level3A'},
                {label: '第3轮_组B升级', prop: 'level3B'},

                {label: '第4轮_组A', prop: 'roud4A'},
                {label: '第4轮_组B', prop: 'round4B'},               
                {label: '第4轮_组A升级', prop: 'level4A'},
                {label: '第4轮_组B升级', prop: 'level4B'},
            ],
            newRound: null,
            pubId: '',
            pubType: '',
         }
     },
     created() {        
        this.pubId = this.$route.query.id
        this.pubType = this.$route.query.type
        // this.newRound = this.$route.query.round
     },
     mounted() {
        this.initData()
        this.getTitle()
        document.addEventListener('click', this.toggleFullScreen);
     },
     computed:{
        ...mapState(['round']),
     },
     methods: {
        tableRowClassName({row, rowIndex}){
            // 前三名不同的颜色
            if(row.rank === 1){
                return 'gold-row'
            }else if(row.rank === 2){
                return  'silver-row'
            }else if(row.rank === 3){
                return  'brown-row'
            }
        },
        // 赛事成绩排名  1014
        getRankQuery(){
            // let params = {
            //     opcode: this.$code.RankScore,
            //     i_serial_mark: this.pubId,
            // }            
            // this.$api._requestAPI(params).then(res=>{
            //     if(res.IsSuccess){
            //         this.isShow = true
            //         let result = res.Data.DataTable
            //         this.tableData =  result.map(item=>{
            //             return {
            //                 number: item['升级数'],
            //                 company: item['单位'],
            //                 rank: item['名次'],
            //                 totalPlayers: item['对手总分'],
            //                 totalMinusPlayers: item['对手总级差分'],
            //                 partnerScore: item['搭档总分'],
            //                 partnerRank: item['搭档总级差分'],
            //                 partnerName: item['搭档名称'],
            //                 score: item['积分'],
            //                 totalRank: item['级差总分'],
            //                 winNum: item['胜轮次'], 
            //                 username: item['选手名称'],
            //                 playersId: item['选手编号'], 
            //                 teamScore: item['总升级'],                                                        
            //             }
            //         })
            //     }
            // })
        },              
        //赛事排名查看 1076
        initData(){
            let params = {
                opcode: this.$code.GroupRankCode,
                i_serial_mark: this.pubId,
             }            
             this.$api._requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    this.isShow = true
                    let result = res.Data.DataTable
                    this.tableData = result.map(item=>{                    
                        return{
                            playersId: item['选手编号'],
                            username: item['选手'],
                            rank: item['名次'],
                            company: item['单位'],
                            winNum: item['总升级'],    
                            roud1A: item['第1轮_组A'],                           
                            roud1B: item['第1轮_组B'],
                            level1A: item['第1轮_组A升级'],
                            level1B: item['第1轮_组B升级'],

                            roud2A: item['第2轮_组A'],                           
                            roud2B: item['第2轮_组B'],
                            level2A: item['第2轮_组A升级'],
                            level2B: item['第2轮_组B升级'],

                            roud3A: item['第3轮_组A'],                           
                            roud3B: item['第3轮_组B'],
                            level3A: item['第3轮_组A升级'],
                            level3B: item['第3轮_组B升级'],
                            
                            roud4A: item['第4轮_组A'],                           
                            roud4B: item['第4轮_组B'],
                            level4A: item['第4轮_组A升级'],
                            level4B: item['第4轮_组B升级'],
                        }
                    })    
                    this.errorMessage = ''    
                let outputArry = this.transformObjectToArray(result[0])
                // 获取所有唯一的字段名
                const fields = Array.from(new Set(this.tableData.flatMap(Object.keys)));
                // 过滤出至少有一个非空值的字段
                let arr= fields.filter(field => this.tableData.some(row => row[field] !== null && row[field] !== undefined && row[field] !== ''));

                this.dynamicHeaders = outputArry.filter(i=>arr.includes(i.prop))

                 }else{
                    // this.errorMessage = res.Message
                    this.$message.error(res.Message)
                    this.isShow = false
                 }
             })  
        },
        transformObjectToArray(obj) {
            const result = [];
            const mapping = {
                '名次': 'rank',
                '单位': 'company',
                '选手': 'username',
                '搭档': 'partnerName',                
                '总升级': 'winNum',
                '第1轮_组A': 'roud1A',
                '第1轮_组B': 'roud1B',
                '第1轮_组A升级': 'level1A',
                '第1轮_组B升级': 'level1B',

                '第2轮_组A': 'roud2A',
                '第2轮_组B': 'roud2B',
                '第2轮_组A升级': 'level2A',
                '第2轮_组B升级': 'level2B',

                '第3轮_组A': 'roud3A',
                '第3轮_组B': 'roud3B',
                '第3轮_组A升级': 'level3A',
                '第3轮_组B升级': 'level3B',

                '第4轮_组A': 'roud4A',
                '第4轮_组B': 'roud4B',
                '第4轮_组A升级': 'level4A',
                '第4轮_组B升级': 'level4B',
            };        
            for (let key in obj) {
                if (obj.hasOwnProperty(key) && mapping.hasOwnProperty(key)) {                  
                    result.push({
                        label: key,
                        prop: mapping[key]
                    });
                }
            }        
            return result;
        },
        getTitle(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.pubId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{                        
                        return{
                            title: item['主题'],
                            // round: item['比赛轮数']
                        }
                    })
                    this.title = list[0].title
                    // this.round = list[0].round
                }
            })
        },  
        toggleFullScreen(){
            if (!document.fullscreenElement) {
                this.$help.enterFullScreen();
            } else {
                this.$help.exitFullScreen();
            }
        },     
     },
     beforeDestroy() {
        // 在实例销毁前移除事件监听
        document.removeEventListener('click', this.toggleFullScreen);
    },
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
    font-size: 28px;
    text-align: center;
    color: gold;
    padding: 10px 0;
    background-color: #de2c11;
 }
 table {
     width: 100%;
     border-collapse: collapse;
   }
   th, td {
     border: 1px solid #999;
     padding: 8px;
     text-align: left;
     font-size: 28px;
   }
   tr:nth-child(even) {
     background-color: lightblue;
   }
   thead th {
     background-color: #f2f2f2;
     font-size: 30px;
     text-align: center;
   }
   .table-label {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px;
     background-color: #f9f9f9;
     border: 1px solid #ddd;
   }
   .custom-table >>> .el-table__header-wrapper tr th{
        // font-size: 18px;
        // color: #333;
    }
.custom-table >>> .cell{
    padding: 2px 0 !important;
    font-size: 24px ;
    color: #000;
    font-family: '黑体';
}
.custom-table >>> .gold-row{
    background-color: #FFD700;
}
.custom-table >>> .silver-row{
    background-color: #C0C0C0;
}
.custom-table >>> .brown-row{
    background-color: #CD7F32;
}
 </style>


// WEBPACK FOOTER //
// src/views/teamFullScreen/fullGroupRankQuery.vue